<template>
  <div class="detail">
    <div class="header">
      <div class="title">{{title}}</div>
      <div class="time">发布时间：{{$moment(time).format("YYYY-MM-DD")}}</div>
    </div>
    <div v-loading="loading" element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="#eee" v-html="content"></div>
  </div>
</template>
<script>
  import {
    getKnowledgeInfo
  } from "@/api/hoaccu";

  export default {
    name: "detail",
    data() {
      return {
        content: "",
        loading: false,
        time:"",
        title:""
      }
    },
    created() {
      this.getInfo();
    },
    methods: {
      getInfo() {
        this.loading = true;
        getKnowledgeInfo({
          page: 1,
          pageSize: 1,
          condition: [
            {
              "key": "id",
              "value": this.$route.params.id
            }
          ]
        }).then(res => {
          if (res.status === 200) {
            if (res.data.data.length) {
              this.content = res.data.data[0].detail;
              this.title = res.data.data[0].title;
              this.time = res.data.data[0].issueTIme;
              this.loading = false;
            } else {
              this.content = "暂无数据";
              this.loading = false;
            }
          } else {
            this.$message.warning(res.message);
            this.loading = false;
          }
        }).catch(err => {
          this.$message.warning(err.message);
          this.loading = false;
        })
      }
    },
  }
</script>
<style lang="less" scoped>
  .detail {
    padding: 10px 0;
    .header{
      border-bottom: 1px dotted #ccc;
      text-align: center;
      margin-bottom: 20px;
      .title{
        font-weight: bold;
        color: #666;
        font-size: 18px;
        margin-bottom: 10px;
      }
      .time{
        color: #666;
        font-size: 13px;
        margin-bottom: 10px;
      }
    }
  }
</style>
